module.exports = __webpack_public_path__ + "images/play.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/play.png
// module id = 963
// module chunks = 2